import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var CalendarIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,4l0,-1c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1l0,1.105c1.154,0.327 2,1.388 2,2.646l0,5.498c0,1.518 -1.232,2.75 -2.751,2.751l-8.498,0c-1.518,0 -2.751,-1.233 -2.751,-2.751l0,-5.498c0,-1.258 0.846,-2.319 2,-2.646l0,-1.105c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1l0,1l6,0Zm-2,3l-1,0l0,0.031c0,0.257 -0.102,0.504 -0.284,0.685c-0.181,0.182 -0.428,0.284 -0.685,0.284l-0.031,0l0,1l1,0l0,3l1,0l0,-5Z"
  }));
});
CalendarIcon.displayName = 'CalendarIcon';
export default CalendarIcon;